@use '@fukuri-admins/ui/layout' as *;

.root {
  box-sizing: border-box;

  @media screen and (max-width: $TB) {
    background-color: background('Primary');
    padding: 48px 24px
  }
}

.container {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

@media (max-width: 1140px) {
  .container {
    padding: 96px 48px;
  }
}

@media (max-width: 700px) {
  .container {
    padding: 48px;
  }
}

@media (max-width: 540px) {
  .container {
    padding: 0;
  }
}

.title {
  text-align: center;
  font-weight: 400;
  font-size: 32px;
  margin-bottom: 40px;
}

.mainContainer {
  width: 100%;
}

.form {
  max-width: 400px;
  margin: 0 0 16px;
  text-align: left;
  color: $Text;
  font-size: 16px;
  .formTitle {
    color: $TextInput;
    font-size: 14px;
    margin-bottom: 4px;
    font-weight: 600;
    text-align: left;
    @media (max-width: 440px) {
      font-size: 12px;
    }
  }
}
